import React, { useEffect } from 'react';
import './AnimatedLogo.css';
import rotatingLogo from '../assets/rotating-logo.png';
import phraseImage from '../assets/phrase-logo.png';

export default function AnimatedLogo({ size = 1 }) {
  useEffect(() => {
    const blocks = document.querySelectorAll('.block_1');
    const randomHeight = (min = 0.3, max = 2.0) =>
      Math.random() * (max - min) + min;

    const animateBlocks = () => {
      blocks.forEach(block => {
        block.style.height = `${randomHeight()}em`;
      });
    };

    const interval = setInterval(animateBlocks, 500);
    animateBlocks();

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="logo-wrapper"
      
    >
      <img className="logo-rotating" src={rotatingLogo} alt="Rotating Logo" />
      <div className="logo-bars">
        <div className="column">
          <div className="block_1 green" />
          <div className="block_1 green" />
        </div>
        <div className="column">
          <div className="block_1 green tall" />
          <div className="block_1 green" />
        </div>
        <div className="column">
          <div className="block_1 blue" />
          <div className="block_1 blue" />
        </div>
      </div>
      <img className="logo-text" src={phraseImage} alt="InsightsFlows" />
    </div>
  );
}
